import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BuildingBuildingClassView, BuildingClassView } from '@api-proxies';
import { BuildingClassService } from '@http/clients/building-class.service';
import { EditorComponentBase, GenericDropdownComponent, GenericDropdownMultiselectComponent } from 'ngx-lib';

@Component({
    selector: 'app-building-class-editor',
    templateUrl: './building-class-editor.component.html',
    styleUrls: ['./building-class-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent, GenericDropdownMultiselectComponent]
})
export class BuildingClassEditorComponent
    extends EditorComponentBase<BuildingBuildingClassView[] | number | null>
    implements OnInit
{
    buildingClassItems?: BuildingClassView[];
    selectedBuildingClass?: BuildingClassView;
    selectedBuildingClasses?: BuildingClassView[];

    constructor(private readonly buildingClassService: BuildingClassService) {
        super();
    }

    async ngOnInit(): Promise<void> {
        this.buildingClassItems = await this.buildingClassService.getAll();

        if (this.buildingClassItems?.length && this.bindingProperty) {
            if (Array.isArray(this.bindingProperty) && this.bindingProperty.length) {
                this.selectedBuildingClasses = this.buildingClassItems.filter((x) =>
                    (this.bindingProperty as BuildingBuildingClassView[])?.some(
                        (obj2) => x['id'] === obj2['buildingClassId']
                    )
                );
            } else {
                this.selectedBuildingClass = this.buildingClassItems.find((x) => x.id === this.bindingProperty);
            }
        }
    }

    onSelectedProductTypeChange() {
        if (this.selectedBuildingClasses)
            this.bindingProperty = this.selectedBuildingClasses.map(
                (x) => ({ buildingClassId: x.id }) as BuildingBuildingClassView
            );
    }

    onSelectBuildingClass() {
        this.bindingProperty = this.selectedBuildingClass?.id ?? null;
        this.valueChange.emit();
    }
}
